import { render, staticRenderFns } from "./AddLocationNewCustomer.vue?vue&type=template&id=49cf260a&scoped=true&"
import script from "./AddLocationNewCustomer.vue?vue&type=script&lang=ts&"
export * from "./AddLocationNewCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./AddLocationNewCustomer.vue?vue&type=style&index=0&id=49cf260a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf260a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VCombobox,VSelect,VTextField,VTextarea})
